import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withRepeat, withTiming, } from 'react-native-reanimated';
import { rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const AnimatingTouchArea = () => {
    const styles = useStyles(styleSet);
    const scale = useSharedValue(1);
    const scaleAnimatedStyle = useAnimatedStyle(() => ({
        transform: [{ scale: scale.value }],
    }), [scale]);
    React.useEffect(() => {
        scale.value = withRepeat(withTiming(0.6, {
            duration: 1000,
        }), -1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<View style={styles.outerCircle}>
      <Animated.View style={[styles.innerCircle, scaleAnimatedStyle]}/>
      <View style={styles.absView}>
        <View style={styles.centerCircle}/>
      </View>
    </View>);
};
export default React.memo(AnimatingTouchArea);
const styleSet = createStyleSheets((colors) => ({
    outerCircle: {
        width: rem(64),
        height: rem(64),
        borderRadius: rem(64),
        alignItems: 'center',
        justifyContent: 'center',
        // @ts-ignore
        backgroundColor: `${colors.elements.brand}30`,
    },
    innerCircle: {
        width: rem(61),
        height: rem(61),
        borderRadius: rem(61),
        // @ts-ignore
        backgroundColor: `${colors.elements.brand}80`,
    },
    absView: {
        ...StyleSheet.absoluteFillObject,
        alignItems: 'center',
        justifyContent: 'center',
    },
    centerCircle: {
        width: rem(22),
        height: rem(22),
        borderWidth: rem(3),
        borderRadius: rem(22),
        borderColor: colors.elements.white,
        backgroundColor: colors.elements.brand,
    },
}));
